module.exports = __webpack_public_path__ + "files/96ef3385b153bf8a229acba1e0b11c86.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Lora-regular.svg
 ** module id = 860
 ** module chunks = 0
 **/